export const apiUrl = "https://api.rydi.net";
export const apiUrlzz = "api.drive.washd.id";
export const apiUrlss = "http://localhost:5000";
